import { PureButton } from '../../../../components';
import React from 'react';
import './form-buttons.scss';

interface Props {
	translations: Translations;
	shouldShowRemove: boolean;
	disabled?: boolean;
	onRemove: () => void;
	onCancel: () => void;
	onApply: () => void;
}

export interface Translations {
	remove: string;
	cancel: string;
	apply: string;
}

const FormButtons: React.FC<Props> = ({ translations, onRemove, onCancel, onApply, shouldShowRemove, disabled }) => {
	return (
		<div className="form-buttons">
			{shouldShowRemove && (
				<PureButton className="remove-button" onClick={onRemove} disabled={disabled}>
					{translations.remove}
				</PureButton>
			)}
			<PureButton className="cancel-button" onClick={onCancel}>
				{translations.cancel}
			</PureButton>
			<PureButton className="apply-button" onClick={onApply} disabled={disabled}>
				{translations.apply}
			</PureButton>
		</div>
	);
};

export default FormButtons;
